import { ApiResponseObject } from "../../types";
import { axios } from "../../utils/axios";
import {
  PuObrazacListPayload,
  PuObrazac,
  IPuObrazac,
} from "./poreskaUprava.types";

const getPuObrasci = (
  payload: PuObrazacListPayload
): Promise<ApiResponseObject<PuObrazac[]>> => {
  return axios.post("listaSvihPuObrazaca", payload);
};

const getSinglePuObrazac = (
  id: number
): Promise<ApiResponseObject<IPuObrazac>> => {
  return axios.get("detaljiPuObrasci", { params: { id } });
};

export const poreskaUpravaRepo = {
  getPuObrasci,
  getSinglePuObrazac,
};
